import type { NormalizedDiscoveryFilters } from "../types/discoveryFilter.types";

export const discoveryKeys = {
  all: ["discovery"] as const,
  search: (
    normalizedFilters: NormalizedDiscoveryFilters,
    userCountry?: string | null
  ) => ["discovery-influencers", normalizedFilters, userCountry] as const,
  profile: (handle: string) => ["discovery-influencer", handle] as const,
};
